export default "__VITE_ASSET__e7f4eb09__"